import React from 'react';
import _ from 'lodash';

import {
  Avatar,
  Box,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  styled,
  Typography
} from '@mui/material';
import {
  AddAuditLogEventModal,
  BaseWidget,
  PermissionWall
} from 'modules';

import { modalUtil } from 'iron-forge-react-modules';
import * as dataService from './dataService';



const ButtonBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginRight: theme.spacing(2)
}));

const SecondaryText = styled('span')({
  display: 'block',
  fontSize: 14
});



export interface IProps {
  orderId?: string;
  storeId: string;
  returnAuthorizationId?: string;
}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useQuery({
    orderId: props.orderId,
    returnAuthorizationId: props.returnAuthorizationId
  });

  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers([
    'addNote',
    'sendEmail'
  ]);



  function handleClickAddNote() {
    setModalIsOpen('addNote', true);
  }



  // function handleClickSendEmail() {
  //   setModalIsOpen('sendEmail', true);
  // }



  function handleCloseAddNoteModal() {
    setModalIsOpen('addNote', false);
  }



  function handleCloseSendEmailModal() {
    setModalIsOpen('sendEmail', false);
  }



  return (
    <>
      <BaseWidget.FC
        title="Audit Log"
        elAction={(
          <ButtonBox>
            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={_.compact([
                props.orderId && 'salesOrder_addAuditLogEvent',
                props.returnAuthorizationId && 'returnAuthorization_addAuditLogEvent'
              ])}>
              <Button
                variant="contained"
                onClick={handleClickAddNote}>
                Add Note
              </Button>
            </PermissionWall.FC>
            {/*
            <PermissionWall.FC
              storeId={props.storeId}
              requiresPermissions={_.compact([
                props.orderId && 'salesOrder_addAuditLogEvent',
                props.returnAuthorizationId && 'returnAuthorization_addAuditLogEvent',
                'customer_email'
              ])}>
              <Button
                variant="contained"
                onClick={handleClickSendEmail}>
                Email Customer
              </Button>
            </PermissionWall.FC> */}
          </ButtonBox>
        )}>

        {!_.isEmpty(tuple.data.events) ? (
          <List>
            {_.map(tuple.data.events, ev => (
              <ListItem key={ev.id}>
                <ListItemAvatar>
                  <Avatar>{ev.triggeredByInitials}</Avatar>
                </ListItemAvatar>

                <ListItemText
                  primary={ev.title}
                  secondary={(
                    <>
                      <SecondaryText>
                        {ev.content}
                      </SecondaryText>

                      <SecondaryText>
                        By {ev.triggeredByFullName} on {ev.createdAt.toFormat('yyyy-MM-dd @ hh:mm a')}
                      </SecondaryText>
                    </>
                  )} />
              </ListItem>
            ))}
          </List>

        ) : (
          <Typography>
            No events
          </Typography>
        )}
      </BaseWidget.FC>

      {modalType2IsOpen.addNote && (
        <AddAuditLogEventModal.FC
          orderId={props.orderId}
          returnAuthorizationId={props.returnAuthorizationId}
          onClose={handleCloseAddNoteModal} />
      )}

      {modalType2IsOpen.sendEmail && (
        <AddAuditLogEventModal.FC
          sendsEmail
          orderId={props.orderId}
          returnAuthorizationId={props.returnAuthorizationId}
          onClose={handleCloseSendEmailModal} />
      )}
    </>
  );
};
